<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="item.className"
      v-html="props[item.valueKey]"
    ></div>
    <div v-html="svg" class="svg"></div>
  </div>
</template>

<script setup lang="tsx">
// import { hexToRgba } from '@/hooks/use-echart/utils';// FIXME:后台展示修改。一个小工具不需要全引用
import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const emits = defineEmits(['posChange', 'valueChange']);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1194.894 1088.978">
  <defs>
    <linearGradient id="linear-gradient" x1="0.5" x2="1" y2="1.301" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--theme-color-1-for-cover-10)"/>
      <stop offset="1" stop-color="#fff"/>
    </linearGradient>
  </defs>
  <g transform="translate(0 -523.087)">
    <path d="M2.457-1.721,8,0l.424,668.1-5.967,4.178Z" transform="matrix(0.574, -0.819, 0.819, 0.574, 679.363, 1243.475)" fill="var(--theme-color-1)"/>
    <path d="M-19839.016,5682.236l521.947,292.815 V5657Z" transform="translate(20535 -4445)" fill="url(#linear-gradient)"/>
    <path d="M-20535,5673.042l1191-510.351v324.146l-1191,313.337Z" transform="translate(20535 -4585)" fill="var(--theme-color-1)"/>
    <path d="M-20534.574,5479.838l1191.506-317.146v317.146l-1191.506,58.155Z" transform="translate(20535 -4266.258)" fill="var(--theme-color-1-for-cover-10)"/>
    <path d="M15481-12984.112v0h0v-3.253L16672-13492.913l0,3.259Z" transform="translate(-15481 14016)" fill="var(--theme-color-1)"/>
  </g>
</svg>
`;

const { info, onPosChange, onValueChange } = useCover(emits);

function hexToRgba(hex, opacity) {
  return (
    'rgba(' +
    parseInt('0x' + hex.slice(1, 3)) +
    ',' +
    parseInt('0x' + hex.slice(3, 5)) +
    ',' +
    parseInt('0x' + hex.slice(5, 7)) +
    ',' +
    opacity +
    ')'
  );
}

document.documentElement.style.setProperty(
  '--theme-color-1-for-cover-10',
  hexToRgba(
    document.documentElement.style.getPropertyValue('--theme-color-1'),
    0.8
  )
);
</script>
<style lang="scss" scoped>
.cover {
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
}
.svg {
  width: calc(100% + 10px);
  position: absolute;
  left: -5px;
  top: 540px;
}

.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
  font-weight: 600;
}
.project-name,
.time {
  max-width: 880px;
  font-size: 32px;
  font-weight: 600;
  color: #484848;
}

.project-name {
  font-size: 63px;
}
.enterprise-name {
  font-size: 32px;
  color: #484848;
  max-width: 80%;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #484848;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
